import React from 'react';
import { track } from '@amplitude/analytics-browser';
import { SurgeonSelection } from '@components/SurgeonSelection/SurgeonSelection';
import { TrackableEventType } from '@components/BaseEventTrackingWrapper/BaseTrackableEvents.types';
import { BaseEventTrackingWrapper } from '@components/BaseEventTrackingWrapper/BaseEventTrackingWrapper';
import { useSingleSurgeonSelection } from '@components/BlockRelease/utils/hooks/useSingleSurgeonSelection/useSingleSurgeonSelection';

const DATA_FIELD = 'blockReleaseRequestPage-releasesSection-surgeonSelect';

const BlockReleaseSurgeonSelection = () => {
	const { filteredSurgeonList, selectedSurgeonFilter, setSelectedSurgeonFilter } = useSingleSurgeonSelection();

	const handleTrackingEvent = React.useCallback((event: React.SyntheticEvent<HTMLElement>) => {
		const eventType = event.type;
		const eventName = `dropdown-${eventType}`;

		track(eventName, { fieldName: DATA_FIELD, eventType: eventType });
	}, []);

	return (
		<BaseEventTrackingWrapper
			handleEvent={handleTrackingEvent}
			dataField={DATA_FIELD}
			eventsToTrack={[TrackableEventType.OnClick]}
		>
			<SurgeonSelection
				selectedSurgeon={selectedSurgeonFilter}
				setSelectedSurgeon={setSelectedSurgeonFilter}
				surgeons={filteredSurgeonList}
			/>
		</BaseEventTrackingWrapper>
	);
};

export default BlockReleaseSurgeonSelection;
